import { NgModule } from '@angular/core';
import { TabStripComponent } from './tab-strip.component';

@NgModule({
  imports: [TabStripComponent],
  exports: [TabStripComponent],
})
export class TabStripModule {}
